import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-amber-900 to-amber-700 px-6">
      <main className="text-center max-w-xs sm:max-w-md">
        <h1
          className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-amber-600 font-extrabold leading-none select-none
        text-6xl sm:text-8xl md:text-[10rem]"
        >
          401
        </h1>
        <h2 className="text-white font-bold mb-4 text-2xl sm:text-3xl md:text-4xl">
          Unauthorized
        </h2>
        <p className="text-amber-200 mb-12 text-sm sm:text-base md:text-lg">
          Sorry, you do not have permission to view this page.
        </p>
        <Link
          to="/login"
          className="inline-block bg-gradient-to-r from-yellow-400 to-amber-600 text-white font-semibold rounded-full px-6 py-2 shadow-lg hover:from-amber-600 hover:to-yellow-400 transition-colors focus:outline-none focus:ring-4 focus:ring-yellow-400 text-base sm:text-lg"
          aria-label="Go back to Home Page"
        >
          Go to Login
        </Link>
      </main>
    </div>
  );
}
